import { render, staticRenderFns } from "./SpecialSpecialtyForm.vue?vue&type=template&id=e5be049e&"
import script from "./SpecialSpecialtyForm.vue?vue&type=script&lang=js&"
export * from "./SpecialSpecialtyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports